import styled from "styled-components";

export const ContainerFrenteOrden = styled.div`
  ${({ isMobile }) => {
    if (isMobile) {
      return `
     
      
       `;
    } else {
      return `
        width: 365px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        `;
    }
  }}
  width: 365px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  @media (max-height:700px) {
    height: 500px;
  }
`;

export const ContainerTopFrenteOrden = styled.div`
  width: 100%;
  height: 67px;
  background: var(--color-secondary-gradient);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  font-size: 18px;
  color: var(--color-white);
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BodyFrenteOrden = styled.div`
  width: 100%;
  height: calc(100% - 67px);
  `;

export const ContianerConsulta = styled.div`
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  h1 {
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
    margin: 0;
    padding: 0;
    width: 320px;
    text-align: center;
  }
  button {
    width: 120px;
    height: 42px;
    border-radius: 8px;
    color: var(--color-white);    
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
  }
  .success {
    background: var(--color-broccoli);
  }
  .danger {
    background-color: var(--color-danger);
  }
  .container-btn {
    display: flex;
    gap: 50px;
  }
  @media (max-height:700px) {    
    height: 100%;
    gap: 100px;
  }
  `;

export const ContainerSeleccionar = styled.div`
 

  width: 100%;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 100px;
  h1 {
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
    margin: 0;
    padding: 0;
  }
  .container-btn-selection {
    button {
      color: var(--color-latex30);
    }
    height: 100px;
    display: flex;
    gap: 30px;
    justify-content: center;
    align-items: flex-end;
  }
  .selection {
    background-color: transparent;
    border-radius: 100%;
    width: 60px;
    height: 60px;
    border: 2px solid var(--color-latex30);
    font-style: normal;
    font-weight: 500;
    font-size: 32px;
    line-height: 150%;
    color: var(--color-latex10);
  }
  .active {
    @keyframes selection-animation {
      0% {
        background-color: transparent;
        border-radius: 100%;
        width: 70px;
        height: 70px;
        border: 2px solid var(--color-latex30);
        font-style: normal;
        font-weight: 500;
        font-size: 32px;
        line-height: 150%;
        color: var(--color-latex10);
      }
      100% {
        background-color: var(--color-latex30);
        border-radius: 100%;
        width: 70px;
        height: 70px;
        border: 2px solid var(--color-latex30);
        font-style: normal;
        font-weight: 500;
        font-size: 32px;
        line-height: 150%;
        color: var(--color-white);
      }
    }

    background-color: var(--color-latex30);
    color: var(--color-white);
    animation: selection-animation 1s forwards;
  }
  .avanzar-btn {
    width: 292px;
    height: 42px;
    background: var(--color-primary);
    color: var(--color-white);
    font-size: 16px;
    font-weight: 700;
    line-height: 150%;
    border-radius: 8px;
  }
  @media (max-height: 700px){
    height: 100%;
    gap: 70px;
  }
`;

export const ContainerSubidaFrente = styled.div`
  width: 100%;
  height: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  h1 {
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
    margin: 0;
    padding: 0;
  }
  span {
    color: var(--color-latex10, #002133);
    text-align: center;
    font-size: 18px;
    line-height: 150%;
  }
  button {
    width: 292px;
    height: 42px;
    background: var(--color-primary);
    color: var(--color-white);
    font-size: 16px;
    font-weight: 700;
    line-height: 150%;
    border-radius: 8px;
  }
  .container-btn {
    display: flex;
    gap: 20px;
    flex-direction: column;
  }
  @media (max-height: 700px){
    height: 100%;
    gap: 20px;
  }
`;

export const ContainerConfirmImage = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  align-items: center;

  button {
    width: 292px;
    height: 42px;
    background: var(--color-primary);
    color: var(--color-white);
    font-size: 16px;
    font-weight: 700;
    line-height: 150%;
    border-radius: 8px;
  }
  .success {
    background: var(--color-broccoli);
  }
  .danger {
    background-color: var(--color-danger);
  }
  .btn-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  h1 {
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
    margin: 0;
    padding: 0;
  }
  padding-bottom: 20px;
  padding-top: 20px;
  @media (max-height:700px){
    height: 100%;
    gap: 20px;
  }
`;
